import React from 'react'
import { SortableContainer } from 'react-sortable-hoc'
import { Row } from 'antd'

import Item from './Item'

function Comp (
    {
        action,
        contents = [],

        onChange,
        onUploading,

        createTemp,
    }
)
{
    return (
        <Row type="flex" >
            {
                contents.map((content, i) =>
                {
                    return (
                        <Item
                            key={content.id}
                            // id={content.id}
                            index={i}
                            sortIndex={i}
                            length={contents.length}
                            onChange={onChange}
                            onUploading={onUploading}
                            createTemp={createTemp}
                            action={action}
                            {...content}
                        />
                    )
                })
                .filter (e => !!e)
            }
        </Row>
    )
}

export default SortableContainer(Comp)